import { isAsyncValidating } from 'redux-form';
export function waitForAsyncValidation(formName, store) {
  return new Promise(resolve => {
    if (!isAsyncValidating(formName)(store.getState())) {
      resolve();
      return;
    }
    const unsubscribe = store.subscribe(() => {
      if (!isAsyncValidating(formName)(store.getState())) {
        unsubscribe();
        resolve();
      }
    });
  });
}
function isPlainObject(val) {
  return typeof val === 'object' && val !== null && !Array.isArray(val);
}

/**
 * Gets a nested value from an object using dot notation.
 * Supports nested paths like "airhelp.value.value"
 *
 * @param obj - The object to get the value from
 * @param path - Dot-separated path (e.g., "airhelp.value.value")
 * @returns The value at the path, or undefined if not found
 */
export function getNestedValue(obj, path) {
  return path.split('.').reduce((current, key) => {
    return isPlainObject(current) ? current[key] : undefined;
  }, obj);
}
//# sourceMappingURL=utils.js.map